<template>
    <div class="Nav">
        <div style="display: flex;">
            <button class="btn btn-toggle-sidebar active" @click="toggleSidebar">Stories</button>
            <button style="width: 95px;" class="btn btn-toggle-legend" @click="toggleLegend">How to read</button>
        </div>


        <div class="wrapper-share">
            <a target="_blank" :href="twitterUrl" style="margin-right: 10px;" class="link">twitter</a>
            <a target="_blank" :href="fbUrl" class="link">facebook</a>
            <!-- <a class="" :href="content.twitter">Twitter</a> -->
        </div>

    </div>
</template>

<script>
    import { mapState } from 'vuex';
    export default {
        name: 'Nav',
        data() {
            return {
                fbUrl: `https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fcurricle.net`,
                twitterUrl: `https://twitter.com/intent/tweet?source=https%3A%2F%2Fcurricle.net&text=Curricle%20Lens:%20The%20history%20of%20harvards%20academia%20unveiled.%20Visualized,%20annotated,%20connected:%20what%20should%20the%20course%20catalog%20look%20like%20in%20the%2021st%20century.%20https%3A%2F%2Fcurricle.net&via=metalabharvard%20@kimay%20@fdnklg`
            }
        },
        computed: {
        ...mapState(['legendToggled', 'sidebarActive'])
        },
        methods: {
            toggleSidebar() {
               
                if (this.legendToggled) {
                    this.legendDisable()
                }

                if (this.sidebarActive) {
                    this.dispatchSidebarActive(false);
                    document.querySelector('.btn-toggle-sidebar').classList.remove('active');
                    document.querySelector('.sidebar-wrapper').classList.remove('visible');
                } else if (!this.sidebarActive) {
                    this.dispatchSidebarActive(true);
                    document.querySelector('.btn-toggle-sidebar').classList.add('active');
                    document.querySelector('.sidebar-wrapper').classList.add('visible');
                }
                
                this.dispatchSidebarToggled();
                

            },
            legendDisable() {
                document.querySelector('.legend').classList.remove('visible');
                document.querySelector('.btn-toggle-legend').classList.remove('active');
                this.$store.dispatch("TOGGLE_LEGEND", false);
            },
            toggleLegend() {
                document.querySelector('.legend').classList.toggle('visible');
                document.querySelector('.btn-toggle-legend').classList.toggle('active');
                document.querySelector('.btn-toggle-sidebar').classList.toggle('active');

                document.querySelector('.sidebar-wrapper').classList.toggle('scrolling');

                this.dispatchLegendToggled();
            },
            dispatchSidebarActive(state) {
                this.$store.dispatch("SET_SIDEBAR_ACTIVE", state)
            },
            dispatchSidebarToggled() {
                let d = Date.now()
                this.$store.dispatch("SET_SIDEBAR_TOGGLED", d);
            },
            dispatchLegendToggled() {
                this.dispatchSidebarToggled();

                let state;

                if (!this.legendToggled) {
                    document.querySelector('.sidebar-wrapper').classList.add('visible');
                    document.querySelector('.btn-toggle-sidebar').classList.remove('active');
                    state = true;
                } else if (this.legendToggled) {
                    // document.querySelector('.sidebar-wrapper').classList.remove('visible');
                    document.querySelector('.btn-toggle-sidebar').classList.add('active');
                    state = false;
                }
                this.$store.dispatch("TOGGLE_LEGEND", state);

            },
         }
    }
</script>

<style lang="scss">
    @import '../assets/style/main.scss';

    .scrolling {
        overflow: scroll;
    }

    .Nav {
        position: absolute;
        bottom: 0;
        left: 0px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        width: auto;
        border: 0px solid black;
        border-style: dashed;
        margin: 10px;
        border-radius: 8px;
        display: none;

        .wrapper-share {
            margin-top: 15px;
            margin-bottom: 15px;
            display: flex;
            font-size: 14px;
            margin-right: 20px;
            align-items: center;
            
            @media screen and (max-width: 500px) {
                font-size: 12px;
            }
        }

        // @media screen and (min-width: 1080px) {
        //     display: none;
        // }

        @media screen and (max-width: 768px) {
            width: 320px;
        }

        @media screen and (max-width: 320px) {
            width: 300px;
            margin: 0 0 10px 0;
        }

        // @media screen and (max-width: 380px) {
        //     width: 280px;
        // }        

        .btn {
            border: none;
            padding: 5px 8px;
            height: 26px;
            border-radius: 4px;
            font-size: $font-size-m;
            background: #EEEEEE;
            cursor: pointer;
            transition: all $time-xs ease;
            margin: 10px;
            font-weight: bold;

            &.active {
                background: black;
                color: white;
            }

            &:hover {
                background: #d4d4d4;
                color: black;
                transition: all $time-xs ease;
            }

            &:focus {
                outline: none;
            }
        }

        .btn-toggle-legend {
            margin-left: 0px;
        }
    }

</style>